

import { applyMiddleware, createStore, compose } from 'redux';
import thunk from 'redux-thunk';
import { combineReducers } from 'redux';

//Middleware
import reactBlockUiMiddleware from 'react-block-ui/reduxMiddleware';
import loggerMiddleware from './middleware/logger';
import currenciesMiddleware from './middleware/currencies';
import updateTotalsMiddleware from './middleware/updateTotals';
import cartTypeMiddleware from './middleware/cartType';
import cartVersionMiddleware from './middleware/cartVersion';
import shippingMiddleware from './middleware/shipping';
import paymentMiddleware from './middleware/payment';
import couponMiddleware from './middleware/coupon';
import stepsMiddleware from './middleware/steps';
import gaEvents from './middleware/gaEvents';
import reactPixelMiddleware from './middleware/reactPixel';

//Reducers
import common from './reducers/common';
import personal from './reducers/personal';
import address from './reducers/address';
import cart from './reducers/cart';
import shipping from './reducers/shipping';
import bundles from './reducers/bundles';
import card from './reducers/card';
import coupon from './reducers/coupon';

//state from localStorage
import { loadState } from './services/localStorageService'

//Auth0 Module
import auth0 from './Modules/auth';

import version from './AppVersion';

const { middleware: auth0middleware, reducer: auth } = auth0({
    domain: process.env.REACT_APP_AUTH0_DOMAIN,
    clientID: process.env.REACT_APP_AUTH0_CLIENT_ID,
    redirectUri: `${window.location.origin}/cart`,
    audience: `https://${process.env.REACT_APP_AUTH0_DOMAIN}/userinfo`,
    responseType: 'token id_token',
    scope: 'token openid',
});


//Combine reducers
const reducers = combineReducers({
    common,
    auth,
    personal,
    address,
    cart,
    shipping,
    bundles,
    card,
    coupon
});

//Load state from LocalStorage
const persistedState = loadState();

let state = undefined;

//Add version to cart
if (persistedState && persistedState.hasOwnProperty('cart')){
    state = {
        ...persistedState,
        cart : {
            ...persistedState.cart,
            version: version
        }
    };
}

//Combine Middleware
const getMiddleware = () => {
    return applyMiddleware(
        thunk,
        gaEvents,
        auth0middleware,
        reactBlockUiMiddleware,
        currenciesMiddleware,
        updateTotalsMiddleware,
        loggerMiddleware,
        paymentMiddleware,
        cartTypeMiddleware,
        cartVersionMiddleware,
        shippingMiddleware,
        couponMiddleware,
        stepsMiddleware,
        reactPixelMiddleware
    );
};

let composeEnhancers = compose;
if (process.env.NODE_ENV !== 'production') {
    composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
}

//Create Store
const store = createStore(reducers, state, composeEnhancers(getMiddleware()));

export default store;